// Define the main sections in order of appearance
export const mainSections = [
  { id: "home", name: "Home", component: "Hero", to: "Home" },
  { id: "about", name: "About Me", component: "AboutMe", to: "About" },
  { id: "gallery", name: "Gallery", component: "GalleryPreview", to: "Gallery" },
  { id: "projects", name: "Project Highlights", component: "Projects", to: "Project Highlights" },
  { id: "books", name: "Favourite Books", component: "BooksSection", to: "Favourite Books" },
  { id: "skills", name: "Tech Skills", component: "Skills", to: "Tech Skills" },
  { id: "contact", name: "Contact", component: "Contact", to: "Contact" }
];

// Helper function to get navigation links
export const getNavigationLinks = () => {
  const routes = [
    { id: "1R", name: "Home", route: "/" },
    { id: "2R", name: "Gallery", route: "/gallery" }
  ];
  
  const to = mainSections.map((section, index) => ({
    id: `${index + 1}T`,
    name: section.name,
    to: section.to
  }));

  return { routes, to };
};
